import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from '../internal/variants.js';
export function Panel({ title, right, children, flush = false, className, style, bodyStyle }) {
    return (_jsxs("section", { className: cx('panel', className), style: style, children: [(title || right) && (_jsxs("div", { className: "panel-head", children: [_jsx("span", { className: "panel-title", children: title }), right] })), _jsx("div", { className: "panel-body", style: { padding: flush ? 0 : undefined, ...bodyStyle }, children: children })] }));
}
/** Card — a Panel without a header; thin alias for a plain padded surface. */
export function Card({ children, className, style }) {
    return (_jsx("div", { className: cx('panel', 'pad', className), style: style, children: children }));
}
//# sourceMappingURL=Panel.js.map